import { useContext, useRef } from "react"
import { useDispatch, useSelector } from "react-redux"
import { GlobalContext } from "../../../../context/GlobalContext"

import { mascaraMoeda, maskCurrency, TypePayment } from "../../../../utils/utils"

import { FaRegCreditCard } from "react-icons/fa6";

import { Payments } from "./Payments"
import { OrderContext } from "../../../../context/OrderContext"
import { Toast } from "../../../../utils/Toast"
import { useMotoboy } from "../../../../hooks/useMotoboy"
import { UPDATE_ORDER, UPDATE_SELECT_ORDER } from "../../../../stores/reducers/OrderReducers"

let timeout = null

export function AllPayments() {
  const { isAccess } = useContext(GlobalContext)
  const { calculatePricingTotal, update } = useContext(OrderContext)
  const { motoboys } = useMotoboy()

  const dispatch = useDispatch()
  const order = useSelector(state => state.order?.orderSelect)

  const frete = maskCurrency(order?.deliveryDistrict?.pricing ?? 0)
  const freeFrete = Boolean(order?.deliveryDistrict?.free ?? 0)
  const moneyChange = maskCurrency(order?.moneyChange ?? 0)

  const { totalWithDiscount, discount, calculateTotal } = calculatePricingTotal(order, true)

  const inputRef = useRef()

  async function onChange(key, valueInput) {
    if (!isAccess('pedidos', 'update')) {
      return Toast.warning('Você não tem permissão para atualizar pedido')
    }

    if (key === 'deliveryDistrict') {
      valueInput = {
        ...order?.deliveryDistrict,
        district: valueInput,
      }
    }

    if (key === 'motoboy' && valueInput !== "Selecione") {
      const dt = motoboys.find(e => e.id === valueInput)
      valueInput = {
        ...dt,
      }
    }

    if (key === 'productsOrders') {
      const product = order?.productsOrders.find((e) => e.id === valueInput.id)
      Reflect.deleteProperty(valueInput, 'id')
      const aux = {
        ...product,
        ...valueInput
      }

      valueInput = order?.productsOrders.map(e => {
        if (e.id !== product.id) {
          return e
        }

        return aux
      })

      const newOrder = {
        ...order,
        [key]: valueInput,
      }

      const totalUpdated = calculateTotal(newOrder)

      const payload = {
        ...newOrder,
        total: totalUpdated
      }

      if (order?.typeOrder === 'mesa') {
        dispatch(UPDATE_SELECT_ORDER(payload))
      }

      if (order?.typeOrder !== 'mesa') {
        dispatch(UPDATE_ORDER(payload))
      }

      await update(false, true, payload)

      return
    }

    const payload = {
      ...order,
      [key]: valueInput
    }

    if (order?.typeOrder === 'mesa') {
      dispatch(UPDATE_SELECT_ORDER(payload))
    }

    if (order?.typeOrder !== 'mesa') {
      dispatch(UPDATE_ORDER(payload))
    }

    clearTimeout(timeout)

    const newTimer = setTimeout(async () => {
      await update(false, true, payload)
    }, 800)

    timeout = newTimer
  }

  return (
    <div className="order-payment-editor" style={{ display: 'flex', flexDirection: 'column', gap: '0.5rem', padding: '2rem' }}>
      {isAccess() !== 'garcom' && (
        <div className="mt-2 mb-3">
          <div style={{ display: 'flex', justifyContent: 'start', alignItems: 'center', gap: '10px', marginBottom: '1.4rem' }}>
            <div style={{ width: '31px', height: '31px', display: 'flex', justifyContent: 'center', alignItems: 'center', backgroundColor: '#ff620025', borderRadius: 10 }}>
              <FaRegCreditCard size={15} color="#ff6200" />
            </div>

            <p style={{ fontSize: 'var(--font-size-section-title)', fontWeight: '600', color: 'gray' }}>Informações de pagamento</p>
          </div>

          <div className="mt-2 order-payment-summary" style={{ borderRadius: 10, backgroundColor: 'rgb(236 240 243 / 53%)', boxShadow: 'rgb(231 231 231) 0px 0px 0px 1px', padding: '1.4rem', marginBottom: '2rem' }}>
            {(order?.typeOrder === 'delivery') && (
              <div className="d-flex align-items-center text-dark justify-content-between p-1">
                <p>Frete</p>

                {freeFrete && (
                  <p style={{ textDecoration: 'line-through' }}>{frete}</p>
                )}

                {!freeFrete && (
                  <p>
                    {frete}
                  </p>
                )}
              </div>
            )}

            {(freeFrete) && (
              <div className="d-flex align-items-center text-dark justify-content-between p-1">
                <p className="text-gray">Desconto de Frete</p>
                {freeFrete && (
                  <p>{frete}</p>
                )}
              </div>
            )}

            <div style={{ display: order?.cupomType ? 'block' : 'none', marginBottom: '0.7rem' }} className="d-flex align-items-center text-dark justify-content-between">
              <p style={{ fontSize: 'var(--font-size-body)', color: "#171717" }}>Cupom de Desconto</p>
              <p style={{ fontSize: 'var(--font-size-body)', color: "#171717", fontWeight: '600' }}>{(order?.cupomType === 'porcentagem' ? `${order?.cupomDiscount}%` : maskCurrency(discount ?? 0))} </p>
            </div>

            <div className="d-flex align-items-center text-dark justify-content-between" style={{ marginBottom: '0.7rem' }}>
              <p style={{ fontSize: 'var(--font-size-body)', color: "#171717" }}>Troco para</p>

              <div style={{ display: 'flex', gap: '0.3rem' }}>
                <p style={{ fontSize: 'var(--font-size-body)', color: "#171717", fontWeight: '600' }}>{moneyChange}</p>
                <p style={{ fontSize: 'var(--font-size-body)', color: "#171717", fontWeight: '500' }}><span style={{ color: '#ff6200' }}>(Troco: {moneyChange === maskCurrency(0) ? maskCurrency(0) : maskCurrency(Number((order?.moneyChange ?? 0) - (totalWithDiscount ?? 0))?.toPrecision(3)) ?? 0})</span></p>
              </div>
            </div>

            <hr style={{ margin: '0.5rem 0', color: 'gray' }} />

            <div className="d-flex align-items-center text-dark justify-content-between">
              <p style={{ fontSize: 'var(--font-size-highlight)', color: '#171717', fontWeight: '600' }}>Total pedido</p>
              <p style={{ fontSize: 'var(--font-size-highlight)', color: '#ff6200', fontWeight: '600' }}>{maskCurrency(totalWithDiscount)}</p>
            </div>
          </div>

          <div className="col-sm-12 order-payment-adjustments">
            <div className="col-sm-12" style={{ marginBottom: '1rem', display: 'flex', gap: '1rem' }}>
              <div style={{ flex: 1 }}>
                <label htmlFor="" className="text-gray" style={{ marginBottom: '0.5rem', fontWeight: 500 }}>Desconto</label>

                <input
                  className="form-control form-control-sm"
                  type="text"
                  value={maskCurrency(order?.discount)}
                  onChange={(e) => onChange('discount', mascaraMoeda(e.target.value))}
                  style={{ height: '30px', borderRadius: 8, width: '100%' }}
                />
              </div>

              <div style={{ flex: 1 }}>
                <label htmlFor="" className="text-gray" style={{ marginBottom: '0.5rem', fontWeight: 500 }}>Acréscimo</label>

                <input
                  className="form-control form-control-sm"
                  type="text"
                  value={maskCurrency(order?.extra)}
                  onChange={(e) => onChange('extra', mascaraMoeda(e.target.value))}
                  style={{ height: '30px', borderRadius: 8, width: '100%' }}
                />
              </div>

              <div style={{ flex: 1 }}>
                <label htmlFor="" className="text-gray" style={{ marginBottom: '0.5rem', fontWeight: 500 }}>Troco</label>

                <input
                  className="form-control form-control-sm"
                  type="text"
                  value={maskCurrency(order?.moneyChange)}
                  onChange={(e) => onChange('moneyChange', mascaraMoeda(e.target.value))}
                  style={{ height: '30px', borderRadius: 8, width: '100%' }}
                />
              </div>
            </div>

            <div className="mt-2 col-sm-4" style={{ minWidth: '150px' }}>
              <label htmlFor="" className="text-gray" style={{ marginBottom: '0.5rem', fontWeight: 500 }}>Forma de pagamento</label>

              <select
                className="form-select form-select-sm text-gray"
                defaultValue={order?.paymentMethod}
                onChange={(e) => onChange('paymentMethod', e.target.value)}
                aria-label=".form-select-sm example"
                style={{ height: '30px', borderRadius: 8 }}
              >
                <option value={TypePayment.money}>Dinheiro</option>
                <option value={TypePayment.card_credit}>Cartão Crédito</option>
                <option value={TypePayment.card_debit}>Cartão Débito</option>
                <option value={TypePayment.pix}>Pix</option>
              </select>
            </div>

            <div className="mt-2 col-sm-12" style={{ width: '100%' }}>
              <label htmlFor="exampleFormControlTextarea1" className="form-label text-gray" style={{ marginBottom: '0.5rem', fontWeight: 500 }}>Descrição</label>

              <textarea className="form-control"
                id="exampleFormControlTextarea1"
                rows="3"
                onChange={(e) => onChange('description', e.target.value)}
                value={order?.description || ''}
                style={{ borderRadius: 8 }}
                placeholder="Observações..."
              >
              </textarea>
            </div>
          </div>
        </div>
      )
      }

      <hr />

      <Payments total={totalWithDiscount} order={order} inputRef={inputRef} />
    </div >
  )
}
